var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 25 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5653_1595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7695 2.23438C21.3286 0.793457 19.4131 0 17.3755 0C15.5737 0 13.8667 0.620606 12.4995 1.76074C11.1328 0.620606 9.42627 0 7.62451 0C5.58691 0 3.67139 0.793457 2.23096 2.23438C-0.743164 5.2085 -0.743164 10.0479 2.23096 13.022L10.5952 21.3862C11.1025 21.8936 11.7793 22.1729 12.5005 22.1729C13.2217 22.1729 13.8984 21.8936 14.4058 21.3862L22.77 13.022C25.7441 10.0479 25.7441 5.2085 22.77 2.23438H22.7695Z",
    fill: "#484888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5653_1595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 22.1724,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.2a30455889d0eaba85a284c71164133f.svg";
export { ForwardRef as ReactComponent };